import React from 'react';

export const parseAccentText = (text) => {
    if (!text) return [];

    // First, split by <br> and create array of lines
    const lines = text.split(/<br\s*\/?>/);

    // Process each line for accent tags
    return lines.map((line, lineIndex) => {
        // Match text between [accent]...[/accent]
        const parts = line.split(/(\[accent\].*?\[\/accent\])/g);

        const processedLine = parts.map((part, partIndex) => {
            if (part.match(/\[accent\](.*?)\[\/accent\]/)) {
                // Extract the text between the tags and return it with styling
                const accentText = part.match(/\[accent\](.*?)\[\/accent\]/)[1];
                return (
                    <span key={`${lineIndex}-${partIndex}`} className="text-green-500">
            {accentText}
          </span>
                );
            }
            // Return regular text
            return <span key={`${lineIndex}-${partIndex}`}>{part}</span>;
        });

        // Return the processed line with a break if it's not the last line
        return (
            <React.Fragment key={`line-${lineIndex}`}>
                {processedLine}
                {lineIndex < lines.length - 1 && <br/>}
            </React.Fragment>
        );
    });
};